import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import actions from 'api/actions';
import _ from 'lodash';
import styles from './styles.module.scss';

class CustomizableForm extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      hasBeenValidated: false,
      errors: {},
      networkError: false
    };
  }

  onSubmit(e) {
    e.preventDefault();

    const {
      fields: propsFields,
      campaignName
    } = this.props;
    const {
      hasBeenValidated,
      errors,
      ...fields
    } = this.state;

    const fieldKeys = Object.keys(propsFields);
    const invalidated = fieldKeys.filter(fieldKey => !propsFields[fieldKey].validation(this.state[fieldKey]));

    if (invalidated.length === 0) {
      actions.post('leads', { ...fields, campaign_name: campaignName })
        .then(r => this.setState({
          success: true,
          networkError: false
        }))
        .catch(e => {
          Sentry.captureException(e);
          this.setState({
            networkError: true
          });
        });
    } else {
      this.setState({
        errors: _.zipObject(
          invalidated, invalidated.map(field => propsFields[field].validationMessage),
        ),
        hasBeenValidated: true
      });
    }
  }

  onChange(e) {
    const { fields } = this.props;
    const { hasBeenValidated, errors } = this.state;
    const field = e.target.name;
    const fieldValue = e.target.value;

    if (!hasBeenValidated) {
      this.setState({ [field]: fieldValue });
    } else {
      if (errors[field] && fields[field].validation(fieldValue)) {
        this.setState(prevState => ({
          errors: _.omit(prevState.errors, field),
          [field]: fieldValue
        }));
      } else {
        this.setState({ [field]: fieldValue });
      }
    }
  }

  render() {
    const {
      errors,
      success,
      networkError
    } = this.state;
    const {
      fields,
      title,
      titleSubtext,
      price,
      discountPrice,
      buttonText
    } = this.props;

    return (
      <div className={styles.customizableForm}>
        {!success ? (
          <React.Fragment>
            {title && (
              <strong className="font-lg">{title}</strong>
            )}
            {price && (
              <p className="text-gray font-130 faded m-0 p-0"><s>{price}</s> value</p>
            )}
            {discountPrice && (
              <p className="text-green font-lg font-heavy m-0 p-0">{discountPrice}</p>
            )}
            {titleSubtext && (
              <p className="p-0 m-0 font-100">{titleSubtext}</p>
            )}
            <form onSubmit={this.onSubmit}>
              {Object.keys(fields).map(field => {
                const fieldData = fields[field];

                return (
                  <div className="form-group">
                    <label htmlFor={fieldData.htmlFor}>{fieldData.labelContent}</label>
                    <input onChange={this.onChange} {...fieldData.input} />
                    {errors[field] && (
                      <strong className="text-red font-heavy pl-1 mt-1">{errors[field]}</strong>
                    )}
                  </div>
                );
              })}
              <button
                disabled={networkError}
                type="submit"
                className={`btn apple ${networkError ? 'disabled' : ''}`}
              >
                {buttonText}
              </button>
              {networkError && (
                <strong className="font-heavy text-red">Sorry, something went wrong on our end. Please refresh and try again.</strong>
              )}
            </form>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <strong className="font-lg">Thanks for your interest</strong>
            <div>We'll be getting back to you within the next 24 hours.</div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default CustomizableForm;
